import { store } from 'v3/data/store';
import { contractStepperSlice } from 'v3/data/store/contractCard/stepper';
import { ContractStepperPayload, GetActiveContractStepper } from './types';

export const setContractStepperState = ({ stepName, error = false, isCompleted = false }: ContractStepperPayload) => {
  const updatedSteppers = store
    .getState()
    .contractStepper.map((step) => (step.name === stepName ? { ...step, error, isCompleted } : step));

  store.dispatch(contractStepperSlice.actions.setContractStepperState(updatedSteppers));
};

export const getActiveContractStepper = (): GetActiveContractStepper => {
  const contractStepper = store.getState().contractStepper;
  const activeStepIndex = contractStepper.findIndex((step) => !step.isCompleted);
  return { activeStep: contractStepper[activeStepIndex], activeStepIndex };
};
